<div class="flex flex-col h-full overflow-hidden relative">
  <div class="flex-1 flex flex-col min-h-0 overflow-hidden">
    @if (tabOptions().length > 1) {
      <div class="shrink-0 w-full min-w-0 overflow-x-auto overflow-y-hidden">
        <p-selectbutton
          class="dsm-tab-toggle shrink-0"
          [options]="tabOptions()"
          optionLabel="label"
          optionValue="value"
          [ngModel]="activeTab()"
          [allowEmpty]="false"
          (onChange)="onTabChange($event.value)"
        />
      </div>
    }
    <div class="flex-1 flex min-h-0 overflow-hidden">
      <div class="flex-1 overflow-hidden flex flex-col">
        <div
          class="flex-1 overflow-hidden flex flex-col gap-5 pt-3"
          [style.display]="activeTab() === 'options' ? null : 'none'"
        >
          <dsm-add-option-options-panel
            #optionsTabPanel
            class="flex flex-col flex-1 min-h-0 gap-5"
            [modelId]="modelId()"
            [elevationId]="elevationId()"
            [lotId]="panelLotId()"
            [addedProductIds]="addedProductIds()"
            [addedProducts]="addedProducts()"
            [selectedEntries]="panelSelectedEntries()"
            [isPackageSource]="isPackageSource()"
            [sidebarPinned]="selectedPanelPinned() && selectedCount() > 0"
            [(filtersVisible)]="filtersVisible"
            (productPicked)="addProduct($event)"
          >
            @if (selectedPanelPinned() && selectedCount() > 0) {
              <div
                optionsSelectedPanel
                class="flex flex-col shrink-0 min-h-0 w-[445px] mt-4 mr-4 mb-4 bg-elevation-one border border-surface-200 rounded-[16px] {{
                  panelLeaving() ? 'sidebar-panel-leave' : 'sidebar-panel-enter'
                }}"
              >
                <ng-container [ngTemplateOutlet]="pinnedPanelInner"></ng-container>
              </div>
            }
          </dsm-add-option-options-panel>
        </div>

        @if (showPackagesTab()) {
          <div
            class="flex-1 overflow-hidden flex flex-col pt-3"
            [style.display]="activeTab() === 'packages' ? null : 'none'"
          >
            <dsm-add-option-packages-tab
              class="flex flex-col flex-1 min-h-0"
              [modelId]="modelId()"
              [elevationId]="elevationId()"
              [addendumId]="addendumId()"
              [addedProductIds]="addedProductIds()"
              (packageEntriesAdded)="onPackageEntriesAdded($event)"
            />
          </div>
        }

        @if (showScenariosTab()) {
          <div
            class="flex-1 overflow-hidden flex flex-col pt-3"
            [style.display]="activeTab() === 'scenarios' ? null : 'none'"
          >
            <dsm-add-option-scenarios-tab
              class="flex flex-col flex-1 min-h-0"
              [modelId]="modelId()"
              [elevationId]="elevationId()"
              [addendumId]="addendumId()"
              [lotId]="panelLotId()"
              [addedProductIds]="addedProductIds()"
              [selectedEntries]="panelSelectedEntries()"
              [sidebarPinned]="selectedPanelPinned() && selectedCount() > 0"
              [active]="activeTab() === 'scenarios'"
              [(filtersVisible)]="filtersVisible"
              (productPicked)="addProduct($event)"
            />
          </div>
        }
      </div>

      @if (selectedPanelPinned() && selectedCount() > 0 && activeTab() !== 'options') {
        <div
          class="shrink-0 flex flex-col border border-surface-200 bg-elevation-one mt-4 mb-4 mr-4 rounded-[16px] w-[445px] {{
            panelLeaving() ? 'sidebar-panel-leave' : 'sidebar-panel-enter'
          }}"
        >
          <ng-container [ngTemplateOutlet]="pinnedPanelInner"></ng-container>
        </div>
      }

      @if (!selectedPanelPinned() && selectedPanelVisible()) {
        <div class="fixed inset-0 bg-black/50 z-[1100] dialog-backdrop-enter" (click)="closeSelectedPanel()"></div>
        <div class="fixed inset-0 z-[1101] flex items-center justify-center pointer-events-none">
          <div
            class="pointer-events-auto bg-[#FBFAF7] rounded-xl shadow-2xl flex flex-col {{
              panelLeaving() ? 'dialog-panel-leave' : 'dialog-panel-enter'
            }}"
            style="width: 1024px; max-width: calc(100vw - 32px); max-height: 75vh"
            (click)="$event.stopPropagation()"
          >
            <div class="flex items-center gap-2 shrink-0 p-5 rounded-t-xl">
              <span class="text-surface-700 text-title-1"> Selected Products </span>
              @if (selectedCount() > 0) {
                <span class="inline-flex items-center justify-center text-emerald-700 text-title-1">
                  ({{ selectedCount() }})
                </span>
              }
              <p-button
                class="hidden lg:inline-flex"
                icon="pi pi-thumbtack !text-[14px] !w-[14px] !h-[14px] !leading-none !flex !items-center !justify-center"
                severity="primary"
                [outlined]="true"
                styleClass="!w-8 !h-8"
                pTooltip="Pin to side"
                tooltipPosition="top"
                (onClick)="togglePin()"
              />
              <p-button
                class="ml-auto"
                icon="pi pi-times"
                [rounded]="true"
                [text]="true"
                severity="secondary"
                size="small"
                aria-label="Close"
                (onClick)="closeSelectedPanel()"
              />
            </div>

            <div class="flex-1 overflow-y-auto px-5 pb-5 flex flex-col gap-3 min-h-0">
              <ng-container [ngTemplateOutlet]="selectedListBody"></ng-container>
            </div>

            <div class="flex items-center justify-between p-5 shrink-0 rounded-b-xl">
              <div class="flex items-center gap-1.5">
                @if (hasSelectedDiscount()) {
                  <span class="text-body-sm text-surface-400 line-through">{{
                    totalSelectedOriginalPrice() | currencyFormat
                  }}</span>
                }
                <span class="text-body-lg-700 text-emerald-700">{{
                  totalSelectedProductsPrice() | currencyFormat
                }}</span>
              </div>
              <div class="flex items-center gap-2">
                @if (saveError()) {
                  <p-message class="my-1" severity="error" size="small" variant="outlined">{{ saveError() }}</p-message>
                }
                <p-button
                  label="Cancel"
                  severity="secondary"
                  [outlined]="false"
                  type="button"
                  (onClick)="closeSelectedPanel()"
                />
                <p-button
                  label="Save Options"
                  type="button"
                  appBtnLoader="dsm-save-options"
                  (onClick)="save()"
                  [disabled]="isSaving() || !selectedCount()"
                />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <ng-template #pinnedPanelInner>
    @if (hasSelectedDiscount()) {
      <div class="flex flex-col gap-1 shrink-0 px-4 py-3">
        <div class="flex items-center gap-2 min-w-0">
          <span class="text-surface-700 text-title-2 whitespace-nowrap"> Selected Products </span>
          @if (selectedCount() > 0) {
            <span class="inline-flex items-center justify-center text-emerald-700 text-title-2 whitespace-nowrap">
              ({{ selectedCount() }})
            </span>
          }
          <p-button
            class="hidden lg:inline-flex shrink-0 ml-auto"
            icon="pi pi-thumbtack !text-[8.5px] !w-[8.5px] !h-[8.5px] !leading-none !flex !items-center !justify-center"
            severity="primary"
            [outlined]="false"
            styleClass="!w-[18.5px] !h-[18.5px] !p-0 !gap-0 !inline-flex !items-center !justify-center"
            pTooltip="Unpin panel"
            tooltipPosition="top"
            (onClick)="togglePin()"
          />
        </div>
        <div class="flex items-center justify-end gap-1.5 text-body-md-700 text-emerald-700 flex-wrap min-w-0">
          <span class="text-surface-400 line-through font-normal">{{
            totalSelectedOriginalPrice() | currencyFormat
          }}</span>
          <span>{{ totalSelectedProductsPrice() | currencyFormat }}</span>
        </div>
      </div>
    } @else {
      <div class="flex items-center gap-2 shrink-0 px-4 py-3">
        <span class="text-surface-700 text-title-2 whitespace-nowrap"> Selected Products </span>
        @if (selectedCount() > 0) {
          <span class="inline-flex items-center justify-center text-emerald-700 text-title-2 whitespace-nowrap">
            ({{ selectedCount() }})
          </span>
        }
        <p-button
          class="hidden lg:inline-flex shrink-0"
          icon="pi pi-thumbtack !text-[8.5px] !w-[8.5px] !h-[8.5px] !leading-none !flex !items-center !justify-center"
          severity="primary"
          [outlined]="false"
          styleClass="!w-[18.5px] !h-[18.5px] !p-0 !gap-0 !inline-flex !items-center !justify-center"
          pTooltip="Unpin panel"
          tooltipPosition="top"
          (onClick)="togglePin()"
        />
        <span class="ml-auto flex items-center gap-1.5 text-body-md-700 text-emerald-700 whitespace-nowrap">
          {{ totalSelectedProductsPrice() | currencyFormat }}
        </span>
      </div>
    }

    <div class="flex-1 overflow-y-auto px-4 pb-4 flex flex-col gap-2 min-h-0">
      <ng-container [ngTemplateOutlet]="selectedListBody"></ng-container>
    </div>
  </ng-template>

  <ng-template #selectedListBody>
    @if (selectedCount()) {
      @for (entry of selectedEntries(); track entry.id) {
        <dsm-selected-product-panel
          [addendumId]="panelAddendumId()"
          [product]="entry.product"
          [inPopup]="!selectedPanelPinned()"
          [quantityEditable]="!isPackageSource()"
          [values]="entry.values"
          [showDeleteIcon]="true"
          [showEditIcon]="!isPackageSource()"
          [discountPercentage]="entry.discountPercentage ?? 0"
          (editRequested)="openEditConfig(entry.id)"
          (removeRequested)="removeProduct(entry.id)"
          (quantityChanged)="updateQuantity(entry.id, $event)"
          (linkedProductUpdated)="onLinkedProductUpdated($event, entry.id)"
        />
      }
    } @else if (!addedProducts().length) {
      <div class="flex flex-col items-center justify-center h-full gap-3 text-surface-400 p-8 text-center">
        <div class="w-12 h-12 rounded-full bg-surface-100 flex items-center justify-center">
          <i class="bi bi-cart-x text-surface-400" style="font-size: 1.25rem"></i>
        </div>
        <p class="text-body-sm-500 text-surface-500 m-0 mb-1">No products selected</p>
        <p class="text-body-xs text-surface-400 m-0">Click Add on any option card to select</p>
      </div>
    }

    @if (addedProducts().length > 0 && selectedCount() > 0) {
      <div class="flex items-center gap-2 py-1">
        <div class="flex-1 h-px bg-surface-200"></div>
        <span class="text-body-xs text-surface-400 uppercase tracking-wider px-2">Already Added</span>
        <div class="flex-1 h-px bg-surface-200"></div>
      </div>
    }

    @if (addedProducts().length > 0) {
      @if (selectedCount() === 0) {
        <div class="flex items-center gap-2 pt-3 pb-1">
          <span class="text-body-xs-700 text-surface-400 uppercase tracking-wider">Already Added</span>
          <span class="text-body-xs text-surface-300">({{ addedProducts().length }})</span>
        </div>
      }
      @for (product of addedProducts(); track product.id) {
        <div class="rounded-[16px] border border-surface-200 bg-surface-100 opacity-70">
          <div class="flex items-center gap-3 p-4 cursor-pointer" (click)="toggleExpandedAddedProduct(product.id)">
            <div class="flex flex-col gap-1 flex-1 min-w-0">
              <span class="text-body-lg-600 text-surface-600 truncate">{{ product.productDescription?.trim() }}</span>
              <span class="text-body-sm text-surface-400 truncate">
                {{ product.categoryName || '—' }} / {{ product.subcategoryName || '—' }}
              </span>
              <span class="inline-flex items-center gap-1 text-body-sm-600 text-surface-500 min-w-0">
                <i class="pi pi-map-marker text-[12px] text-amber-600"></i>
                <span class="truncate">
                  @if (product.locationCode || product.locationName) {
                    {{ product.locationCode }}{{ product.locationName ? ' - ' + product.locationName : '' }}
                  } @else {
                    —
                  }
                </span>
              </span>
            </div>
            <i
              class="pi flex-shrink-0 text-surface-400 text-sm transition-transform duration-200"
              [class.pi-chevron-down]="!expandedAddedProductIds().has(product.id)"
              [class.pi-chevron-up]="expandedAddedProductIds().has(product.id)"
            ></i>
          </div>
          <!-- Price row, matching the selected product cards (read-only qty) -->
          <div class="flex items-center justify-between gap-3 px-4 pb-4 -mt-2">
            <div class="flex items-baseline gap-2 min-w-0 flex-wrap">
              <span class="text-[14px] text-emerald-700 whitespace-nowrap"
                >{{ product.unitPrice | currencyFormat }} ea</span
              >
              <span class="text-[14px] font-bold text-emerald-700 whitespace-nowrap">{{
                product.quantity * product.unitPrice | currencyFormat
              }}</span>
            </div>
            <span class="text-[12px] font-medium leading-none text-[#314022] whitespace-nowrap">{{
              product.quantity
            }}</span>
          </div>
          @if (expandedAddedProductIds().has(product.id)) {
            <div class="p-4 border-t border-surface-200">
              <div class="grid grid-cols-2 gap-5">
                <div>
                  <span class="text-body-xs uppercase tracking-wide text-surface-700">Location</span>
                  <p class="m-0 mt-0.5 text-body-500 text-surface-700">
                    {{
                      product.locationCode
                        ? product.locationCode + (product.locationName ? ' - ' + product.locationName : '')
                        : '—'
                    }}
                  </p>
                </div>

                @for (attr of product.attributes; track attr.subCategoryAttributeId) {
                  <div>
                    <span class="text-body-xs uppercase tracking-wide text-surface-700">{{
                      attr.subCategoryAttribute
                    }}</span>
                    <p class="m-0 mt-0.5 text-body-500 text-surface-700">
                      @for (val of attr.subCategoryAttributeValues; track val.subCategoryAttributeValueId) {
                        {{ val.subCategoryAttributeValue }}{{ !$last ? ', ' : '' }}
                      }
                    </p>
                  </div>
                }

                <div>
                  <span class="text-body-xs uppercase tracking-wide text-surface-700">Unit Price</span>
                  <p class="m-0 mt-0.5 text-body-500 text-surface-700">
                    {{ product.unitPrice | currencyFormat }}
                  </p>
                </div>

                <div>
                  <span class="text-body-xs uppercase tracking-wide text-surface-700">Quantity</span>
                  <p class="m-0 mt-0.5 text-body-500 text-surface-700">{{ product.quantity }}</p>
                </div>

                @if (product.discount > 0) {
                  <div>
                    <span class="text-body-xs uppercase tracking-wide text-surface-700">Discount</span>
                    <p class="m-0 mt-0.5 text-body-500 text-surface-700">
                      {{ product.discount | currencyFormat }}
                    </p>
                  </div>
                }

                <div>
                  <span class="text-body-xs uppercase tracking-wide text-surface-700">Total</span>
                  <p class="m-0 mt-0.5 text-body-500 text-surface-700">{{ product.amount | currencyFormat }}</p>
                </div>

                <div class="col-span-2">
                  <span class="text-body-xs uppercase tracking-wide text-surface-700">Sales Description</span>
                  <p class="m-0 mt-0.5 text-body-500 text-surface-700">
                    {{ product.salesDescription || '—' }}
                  </p>
                </div>

                <div class="col-span-2">
                  <span class="text-body-xs uppercase tracking-wide text-surface-700">Option Notes</span>
                  <p class="m-0 mt-0.5 text-body-sm text-surface-700 whitespace-pre-wrap">
                    {{ product.notes || '—' }}
                  </p>
                </div>
              </div>

              @if (product.linkedProducts.length) {
                <div class="mt-3 flex flex-col gap-3">
                  <span class="text-body-xs uppercase tracking-wide text-surface-700">Linked Options</span>
                  @for (linked of product.linkedProducts; track linked.id) {
                    <div class="rounded-lg border border-surface-200 bg-white p-3 flex flex-col gap-1">
                      <span class="text-body-sm-600 text-surface-600">{{ linked.productDescription?.trim() }}</span>
                      <div class="flex flex-wrap gap-x-4 gap-y-1 text-body-xs text-surface-400">
                        <span
                          >Qty: <span class="text-body-xs-700 text-surface-500">{{ linked.quantity }}</span></span
                        >
                        <span
                          >Unit Price:
                          <span class="text-body-xs-700 text-surface-500">{{
                            linked.unitPrice | currencyFormat
                          }}</span></span
                        >
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    }
  </ng-template>

  @if (!isBasketSource()) {
    <div class="flex sm:!items-center sm:!justify-between flex-shrink-0 bg-transparent pt-2 mt-5 flex-col sm:!flex-row">
      <div class="flex items-center gap-1.5">
        <span class="text-body text-surface-700">Total:</span>
        @if (hasSelectedDiscount()) {
          <span class="text-body-sm text-surface-400 line-through">{{
            totalSelectedOriginalPrice() | currencyFormat
          }}</span>
        }
        <span class="text-body-lg-700 text-emerald-700">{{ totalSelectedProductsPrice() | currencyFormat }}</span>
      </div>

      <div class="flex flex-col gap-1 ms-auto sm:!ms-0 items-end">
        <div class="flex items-center gap-2">
          <p-button label="Cancel" severity="secondary" [outlined]="false" type="button" (onClick)="close()" />
          @if (selectedCount() > 0 && !selectedPanelPinned() && !selectedPanelVisible()) {
            <p-button
              [label]="'View Selected (' + selectedCount() + ')'"
              severity="warn"
              type="button"
              (onClick)="openSelectedPanel()"
            />
          }

          @if (selectedCount() > 0 && (selectedPanelPinned() || !selectedPanelPinned()) && !selectedPanelVisible()) {
            <p-button
              label="Save Options"
              type="button"
              appBtnLoader="dsm-save-options"
              (onClick)="save()"
              [disabled]="isSaving() || !selectedCount()"
            />
          }
        </div>
        @if (saveError()) {
          <p-message class="my-1 me-1" severity="error" size="small" variant="outlined">{{ saveError() }}</p-message>
        }
      </div>
    </div>
  }

  <p-dialog
    [visible]="productConfigDialogVisible()"
    (visibleChange)="onProductConfigDialogVisibilityChange($event)"
    [modal]="true"
    [style]="{ width: isActiveKit() ? '1024px' : '500px', maxWidth: '95vw', background: '#FBFAF7' }"
    [contentStyle]="{ overflowY: 'auto', maxHeight: 'calc(80vh - 130px)' }"
    [draggable]="false"
    [resizable]="false"
    [baseZIndex]="11000"
    appendTo="body"
  >
    <ng-template pTemplate="header">
      <div class="flex items-center gap-2">
        <span class="text-title-1 text-surface-700">{{ configDialogHeader() }}</span>
        @if (isActiveKit()) {
          <p-tag value="KIT" severity="info" size="small" />
        }
      </div>
    </ng-template>
    @if (activeProduct(); as product) {
      @if (product.isKit) {
        <dsm-kit-option-config-form
          [product]="product"
          [addendumId]="panelAddendumId()"
          [initialValues]="initialValues()"
          (commit)="onKitCommit($event)"
        />
      } @else if (isNewConfigEntry()) {
        <dsm-selected-product-multi-location-form
          [product]="product"
          [addendumId]="panelAddendumId()"
          (commit)="onConfigCommit($event)"
        />
      } @else {
        <dsm-selected-product-config-form
          [product]="product"
          [initialValues]="initialValues()"
          [addendumId]="panelAddendumId()"
          (commit)="onEditCommit($event)"
        />
      }
    }
    <ng-template pTemplate="footer">
      @if (isActiveKit()) {
        <div class="flex items-center mr-auto">
          <span class="text-body-lg-700 text-emerald-700">{{ kitTotalValue() | currencyFormat }}</span>
        </div>
      } @else if (isNewConfigEntry() && configLocationCount() > 0) {
        <div class="flex items-center mr-auto">
          <span class="text-body-lg-700 text-emerald-700">{{ configTotalValue() | currencyFormat }}</span>
        </div>
      } @else if (!isNewConfigEntry()) {
        <div class="flex items-center mr-auto">
          <span class="text-body-lg-700 text-emerald-700">{{ editTotalValue() | currencyFormat }}</span>
        </div>
      }
      <p-button label="Cancel" severity="secondary" type="button" (onClick)="cancelProductConfig()" />
      @if (isActiveKit()) {
        <p-button
          [label]="isNewConfigEntry() ? 'Add Kit Option' : 'Update Kit Option'"
          type="button"
          (onClick)="confirmProductConfig()"
        />
      } @else {
        <p-button
          [label]="
            isNewConfigEntry()
              ? configLocationCount() > 1
                ? 'Add ' + configLocationCount() + ' Options'
                : 'Add Option'
              : 'Update Option'
          "
          type="button"
          [disabled]="isNewConfigEntry() && (configLocationCount() === 0 || configBlockedByMissingAttributes())"
          (onClick)="confirmProductConfig()"
        />
      }
    </ng-template>
  </p-dialog>
</div>
